import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "splashCard"

export const presets = {}

export interface Props extends Component {}

export function SplashCard({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`p-8 rounded bg-surface`, className)} data-test={testId}>
      {children}
    </div>
  )
}
